import React, { useState, useEffect, useContext, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './Report.css';
import { LoginContext } from '../Login/LoginContext';
import Url from '../Url';
import { FaChartPie } from 'react-icons/fa'; // Add this line for dashboard icon (install react-icons if not present)

export default function Reportable() {
    const [reportData, setReportData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterType, setFilterType] = useState('all');
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedDate, setSelectedDate] = useState('');
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [dashboardMode, setDashboardMode] = useState(false); // Add dashboard mode state
    const lastF8Time = useRef(0);
    const location = useLocation();
    const { report_id, title,user_id } = location.state || {};
    const { loginResult } = useContext(LoginContext);

    useEffect(() => {
        console.log('User ID:', user_id);
        console.log('Report ID:', report_id);
        const params = JSON.stringify({ report_id, user_id });
        const apiUrl = `${Url.Url}/get_report?data=${params}`;

        setLoading(true);

        fetch(apiUrl)
            .then(response => response.json())
            .then(data => {
                if (Array.isArray(data) && data.length > 0) {
                    setReportData(data);
                    setFilteredData(data);
                } else {
                    setReportData([]);
                    setFilteredData([]);
                }
            })
            .catch(error => console.error('Error fetching data:', error))
            .finally(() => setLoading(false));
    }, [report_id, loginResult, user_id]);

    // Helper functions for date filtering
    const isToday = (date) => {
        const today = new Date();
        const d = new Date(date);
        return d.getDate() === today.getDate() && d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear();
    };
    const isThisWeek = (date) => {
        const now = new Date();
        const d = new Date(date);
        const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay()));
        const endOfWeek = new Date(startOfWeek);
        endOfWeek.setDate(startOfWeek.getDate() + 6);
        return d >= startOfWeek && d <= endOfWeek;
    };
    const isThisMonth = (date) => {
        const now = new Date();
        const d = new Date(date);
        return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
    };

    // Extract unique usernames, dates, and statuses for dropdowns and status filter
    // Calculate unique users from reportData for dropdown (fix: use reportData, not filteredData)
    const userField = reportData[0] && Object.keys(reportData[0]).find(key => key.toLowerCase().includes('user'));
    const uniqueUsers = userField ? [...new Set(reportData.map(item => item[userField]))] : [];
    const dateField = reportData[0] && Object.keys(reportData[0]).find(key => key.toLowerCase().includes('date'));
    // Calculate statusBaseData: data filtered by all filters except status
    let statusBaseData = reportData;
    if (report_id === 50 && Array.isArray(reportData) && reportData.length > 0) {
        if (filterType !== 'all' && dateField) {
            let filterFn = () => true;
            if (filterType === 'today') filterFn = item => isToday(item[dateField]);
            if (filterType === 'week') filterFn = item => isThisWeek(item[dateField]);
            if (filterType === 'month') filterFn = item => isThisMonth(item[dateField]);
            statusBaseData = statusBaseData.filter(filterFn);
        }
        if (selectedUser) {
            statusBaseData = statusBaseData.filter(item => item[userField] === selectedUser);
        }
        if (selectedDate) {
            statusBaseData = statusBaseData.filter(item => item[dateField] === selectedDate);
        }
    }
    // Calculate unique statuses and counts from statusBaseData
    const statusField = reportData[0] && Object.keys(reportData[0]).find(key => key.toLowerCase().includes('status'));
    const uniqueStatuses = statusField ? [...new Set(statusBaseData.map(item => item[statusField]))] : [];
    const filteredUniqueStatuses = uniqueStatuses.filter(s => s !== undefined && s !== null && String(s).trim() !== '');
    // Count for each status (from reportData)
    const statusCounts = {};
    if (statusField) {
        for (const status of filteredUniqueStatuses) {
            statusCounts[status] = statusBaseData.filter(item => item[statusField] === status).length;
        }
    }
    const totalStatusCount = statusField ? statusBaseData.length : 0;

    const [selectedStatus, setSelectedStatus] = useState('');

    useEffect(() => {
        if (report_id !== 50) {
            setFilteredData(reportData);
            return;
        }
        if (!Array.isArray(reportData) || reportData.length === 0) {
            setFilteredData([]);
            return;
        }
        let filtered = reportData;
        if (filterType !== 'all' && dateField) {
            let filterFn = () => true;
            if (filterType === 'today') filterFn = item => isToday(item[dateField]);
            if (filterType === 'week') filterFn = item => isThisWeek(item[dateField]);
            if (filterType === 'month') filterFn = item => isThisMonth(item[dateField]);
            filtered = filtered.filter(filterFn);
        }
        if (selectedUser) {
            filtered = filtered.filter(item => item[userField] === selectedUser);
        }
        if (selectedDate) {
            filtered = filtered.filter(item => item[dateField] === selectedDate);
        }
        if (selectedStatus) {
            filtered = filtered.filter(item => item[statusField] === selectedStatus);
        }
        setFilteredData(filtered);
    }, [filterType, reportData, report_id, selectedUser, selectedDate, selectedStatus, userField, dateField, statusField]);

    // Reset selectedStatus when main filters change
    useEffect(() => {
        setSelectedStatus('');
    }, [filterType, selectedUser, selectedDate]);
    const [showModal, setShowModal] = useState(false);
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [message, setMessage] = useState('');
    const [email, setEmail] = useState('');
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!(loginResult.user_type === 'team_head' || loginResult.user_type === 'leader')) {
            setMessage('Only team head or leader can add employees.');
            return;
        }

        const payload = {
            Name: name,
            Mobilenumber: mobile,
            Email: email,
            user_type: 'team_member',
            Under_id: loginResult.user_id,
            postid: 2
        };

        try {
            const response = await fetch(`${Url.Url}/post_data`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ data: payload })
            });

            if (response.ok) {
                setMessage('Employee added successfully!');
                setTimeout(() => setShowModal(false), 1000);
            } else {
                setMessage('Failed to add employee.');
            }
        } catch (err) {
            console.error('Error:', err);
            setMessage('Error occurred while adding employee.');
        }
    };

    const handleAddEmployee = () => {
        setShowModal(true);
        setMessage('');
        setName('');
        setMobile('');
        setEmail('');
    };
    const lastF2Time = useRef(0); // Make sure this is F2 if you're using F2

    // Double F8 key detection
    useEffect(() => {
        const handleKeyDown = (e) => {
            const now = Date.now();

            if (e.key === 'F2') {
                if (now - lastF2Time.current < 400) {
                    setShowOffcanvas(true);
                }
                lastF2Time.current = now;
            }

            if (e.key === 'Escape') {
                setShowOffcanvas(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);
    

    // Filter data by date range
    const handleDateFilter = () => {
        if (!fromDate || !toDate || !dateField) {
            setShowOffcanvas(false);
            return;
        }
        const from = new Date(fromDate);
        const to = new Date(toDate);
        const filtered = reportData.filter(item => {
            const d = new Date(item[dateField]);
            return d >= from && d <= to;
        });
        setFilteredData(filtered);
        setShowOffcanvas(false);
    };

    // Pie chart data extraction for dashboard mode (always use filteredData)
    // Assign unique color per status using a palette
    const colorPalette = [
        "#4e79a7", "#f28e2b", "#e15759", "#76b7b2", "#59a14f", "#edc949",
        "#af7aa1", "#ff9da7", "#9c755f", "#bab0ab", "#b07aa1", "#7a9cb0"
    ];
    let pieChartData = [];
    let statusColorMap = {};
    if (
        dashboardMode &&
        Array.isArray(filteredData) &&
        filteredData.length > 0 &&
        filteredData[0].status !== undefined &&
        filteredData[0].lead_count !== undefined
    ) {
        // Assign a color to each unique status
        const uniqueStatuses = [...new Set(filteredData.map(item => item.status))];
        uniqueStatuses.forEach((status, idx) => {
            statusColorMap[status] = colorPalette[idx % colorPalette.length];
        });
        pieChartData = filteredData.map(item => ({
            label: item.status,
            value: item.lead_count,
            percentage: item.percentage,
            color: statusColorMap[item.status],
            recommendation: item.recommendation,
            category: item.category
        }));
    }

    // Pie chart rendering function (SVG) with tooltip on hover
    function PieChart({ data, size = 240 }) {
        const [hoverIdx, setHoverIdx] = useState(null);
        const total = data.reduce((sum, d) => sum + d.value, 0);
        let cumulative = 0;
        const center = size / 2, radius = size / 2 - 20;
        return (
            <div style={{position:'relative', width:size, height:size}}>
                <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
                    {data.map((slice, i) => {
                        const startAngle = (cumulative / total) * 2 * Math.PI;
                        const endAngle = ((cumulative + slice.value) / total) * 2 * Math.PI;
                        const x1 = center + radius * Math.sin(startAngle);
                        const y1 = center - radius * Math.cos(startAngle);
                        const x2 = center + radius * Math.sin(endAngle);
                        const y2 = center - radius * Math.cos(endAngle);
                        const largeArc = slice.value / total > 0.5 ? 1 : 0;
                        const pathData = [
                            `M ${center} ${center}`,
                            `L ${x1} ${y1}`,
                            `A ${radius} ${radius} 0 ${largeArc} 1 ${x2} ${y2}`,
                            'Z'
                        ].join(' ');
                        const midAngle = (startAngle + endAngle) / 2;
                        const labelX = center + (radius / 1.5) * Math.sin(midAngle);
                        const labelY = center - (radius / 1.5) * Math.cos(midAngle);
                        cumulative += slice.value;
                        return (
                            <g key={i}
                                onMouseEnter={() => setHoverIdx(i)}
                                onMouseLeave={() => setHoverIdx(null)}
                                style={{cursor:'pointer'}}
                            >
                                <path
                                    d={pathData}
                                    fill={slice.color}
                                    stroke="none"
                                    // strokeWidth={hoverIdx === i ? 4 : 2} // Remove strokeWidth
                                    opacity={hoverIdx === null || hoverIdx === i ? 1 : 0.6}
                                />
                                {slice.percentage > 5 && (
                                    <text
                                        x={labelX}
                                        y={labelY}
                                        textAnchor="middle"
                                        alignmentBaseline="middle"
                                        fontSize="13"
                                        fill="#222"
                                        fontWeight={hoverIdx === i ? "bold" : "normal"}
                                    >
                                        {slice.percentage}%
                                    </text>
                                )}
                            </g>
                        );
                    })}
                </svg>
                {/* Tooltip */}
                {hoverIdx !== null && (
                    <div
                        style={{
                            position: 'absolute',
                            left: size/2 + 20,
                            top: size/2 - 60,
                            background: '#fff',
                            border: '1px solid #ccc',
                            borderRadius: 8,
                            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                            padding: '12px 18px',
                            zIndex: 10,
                            minWidth: 180,
                            pointerEvents: 'none'
                        }}
                    >
                        <div style={{fontWeight:'bold',marginBottom:4}}>{data[hoverIdx].label}</div>
                        <div style={{fontSize:13,marginBottom:2}}>Category: <b>{data[hoverIdx].category}</b></div>
                        <div style={{fontSize:13,marginBottom:2}}>Leads: <b>{data[hoverIdx].value}</b> ({data[hoverIdx].percentage}%)</div>
                        <div style={{fontSize:13,marginTop:6,color:'#007bff'}}>{data[hoverIdx].recommendation}</div>
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className="enrollment-report-container">
            {/* Offcanvas for date range filter */}
            {showOffcanvas && (
                <div className="offcanvas-overlay" onClick={() => setShowOffcanvas(false)}>
                    <div className="offcanvas-panel" onClick={e => e.stopPropagation()} style={{position:'fixed',right:0,top:0,height:'100%',width:'320px',background:'#fff',boxShadow:'-2px 0 8px rgba(0,0,0,0.2)',zIndex:1000,padding:'24px'}}>
                        <h3>Select Date Range</h3>
                        <div style={{marginBottom:'16px'}}>
                            <label>From Date:</label>
                            <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{width:'100%'}} />
                        </div>
                        <div style={{marginBottom:'16px'}}>
                            <label>To Date:</label>
                            <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={{width:'100%'}} />
                        </div>
                        <button onClick={handleDateFilter} style={{width:'100%',padding:'10px',background:'#007bff',color:'#fff',border:'none',borderRadius:'4px'}}>Done</button>
                    </div>
                </div>
            )}

            {loading && (
                <div className="loader-popup-overlay">
                    <div className="loader-popup">
                        <div className="rich-loader"></div>
                        <h4 className="loader-text">Fetching data, just a moment...</h4>
                    </div>
                </div>
            )}

            <div
                className="title-search-wrapper"
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center', // center the heading and icon
                    gap: 10
                }}
            >
                <h2
                    className="responsive-title"
                    style={{
                        margin: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center', // ensure text and icon are centered together
                        width: '100%',
                        textAlign: 'center'
                    }}
                >
                    {title}
                    {report_id === 52 && (
                        <button
                            style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: 24,
                                marginLeft: 8,
                                color: dashboardMode ? '#007bff' : '#333',
                                display: 'inline-flex',
                                alignItems: 'center'
                            }}
                            title={dashboardMode ? "Show Table View" : "Show Dashboard"}
                            onClick={() => setDashboardMode(m => !m)}
                        >
                            <FaChartPie />
                        </button>
                    )}
                </h2>
            </div>
            {report_id === 50 && statusField && (
                <div className="status-bar">
                    <button
                        className={`status-button${!selectedStatus ? ' status-active' : ''}`}
                        onClick={() => setSelectedStatus('')}
                    >
                        <span className="status-label">All</span>
                        <span className="status-count">{totalStatusCount}</span>
                    </button>
                    {filteredUniqueStatuses.map((status, idx) => (
                        <button
                            key={idx}
                            className={`status-button${selectedStatus === status ? ' status-active' : ''}`}
                            onClick={() => setSelectedStatus(selectedStatus === status ? '' : status)}
                        >
                            <span className="status-label">{status}</span>
                            <span className="status-count">{statusCounts[status]}</span>
                        </button>
                    ))}
                </div>
            )}
            {report_id === 50 && (
                <div className="filter-bar">
                    <div className="date-filters button-group">
                        <button className={`proceed-button${filterType === 'all' ? '-active' : ''}`} onClick={() => setFilterType('all')}>All</button>
                        <button className={`proceed-button${filterType === 'today' ? '-active' : ''}`} onClick={() => setFilterType('today')}>Current Date</button>
                        <button className={`proceed-button${filterType === 'week' ? '-active' : ''}`} onClick={() => setFilterType('week')}>Current Week</button>
                        <button className={`proceed-button${filterType === 'month' ? '-active' : ''}`} onClick={() => setFilterType('month')}>Current Month</button>
                    </div>
                    <div className="dropdown-group">
                        <select className="custom-dropdown username-dropdown" value={selectedUser} onChange={e => setSelectedUser(e.target.value)}>
                            <option value="">All Users</option>
                            {uniqueUsers.map((user, idx) => (
                                <option key={idx} value={user}>{user}</option>
                            ))}
                        </select>
                        {/* <input
                            type="date"
                            className="custom-dropdown"
                            value={selectedDate}
                            onChange={e => setSelectedDate(e.target.value)}
                            placeholder="Select Date"
                        /> */}
                    </div>
                </div>
            )}
            {report_id === 51 && (
                    <button className="addemp-button" onClick={handleAddEmployee}>+ Add Employee</button>
            )}

            <div className="report-container">
                {/* Dashboard Pie Chart for report_id 52 */}
                {report_id === 52 && dashboardMode ? (
                    <div className="piechart-responsive-wrapper">
                        <PieChart data={pieChartData} />
                        <div className="piechart-labels">
                            {pieChartData.map((slice, idx) => (
                                <div key={idx} className="piechart-label-item">
                                    <span style={{
                                        display:'inline-block',
                                        width:16,
                                        height:16,
                                        background:slice.color,
                                        borderRadius:3,
                                        marginRight:8
                                    }}></span>
                                    <strong>{slice.label}</strong>
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    <>
                        <table className="report-table">
                            <thead>
                                <tr>
                                    {Object.keys(filteredData[0] || {}).map((key, index) => (
                                        <th key={index}>{key.replace(/_/g, ' ')}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredData.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            {Object.keys(item).map((key, subIndex) => (
                                                <td key={subIndex}>{String(item[key])}</td>
                                            ))}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <div className="report-cards">
                            {filteredData.map((item, index) => (
                                <div key={index} className="report-card">
                                    {Object.keys(item).map((key, subIndex) => (
                                        <div key={subIndex} className="report-card-item">
                                            <strong>{key.replace(/_/g, ' ')}:</strong> {item[key]}
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </>
                )}
            </div>
            {showModal && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h3>Add New Employee</h3>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Name:</label>
                                <input
                                    type="text"
                                    required
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Mobile Number:</label>
                                <input
                                    type="text"
                                    required
                                    value={mobile}
                                    onChange={(e) => setMobile(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>Email:</label>
                                <input
                                    type="email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <label>User Type:</label>
                                <input
                                    type="text"
                                    value="team_member"
                                    disabled
                                    readOnly
                                />
                            </div>
                            <button type="submit" className="add-button">Submit</button>
                            <button type="button" className="cancel-button" onClick={() => setShowModal(false)}>Cancel</button>
                            {message && <p className="status-msg">{message}</p>}
                        </form>
                    </div>
                </div>
            )}
            <style>
                {`
                .piechart-responsive-wrapper {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    margin: 24px 0;
                    gap: 32px;
                }
                .piechart-labels {
                    margin-top: 0;
                    display: flex;
                    flex-direction: column;
                    flex-wrap: wrap;
                    max-height: 240px;
                }
                .piechart-label-item {
                    display: flex;
                    align-items: center;
                    margin-bottom: 10px;
                    min-width: 120px;
                }
                @media (max-width: 600px) {
                    .piechart-responsive-wrapper {
                        flex-direction: column;
                        align-items: stretch;
                        gap: 16px;
                    }
                    .piechart-labels {
                        flex-direction: row;
                        flex-wrap: wrap;
                        max-height: none;
                        margin-top: 12px;
                    }
                    .piechart-label-item {
                        width: 50%;
                        min-width: 0;
                        margin-bottom: 8px;
                    }
                }
                `}
            </style>
        </div>
    );
}